function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_67737",
  "data-name": "Group 67737",
  transform: "translate(2 2.667)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52281",
  "data-name": "Path 52281",
  d: "M6.414,4.586a2,2,0,1,1-2.828,0,2,2,0,0,1,2.828,0",
  transform: "translate(-3 -4)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52282",
  "data-name": "Path 52282",
  d: "M16.333,7H9",
  transform: "translate(-5 -5)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52283",
  "data-name": "Path 52283",
  d: "M18.414,14.586a2,2,0,1,1-2.828,0,2,2,0,0,1,2.828,0",
  transform: "translate(-7 -7.333)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52284",
  "data-name": "Path 52284",
  d: "M4,17h7.333",
  transform: "translate(-3.333 -8.333)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52285",
  "data-name": "Path 52285",
  d: "M0,0H16V16H0Z",
  fill: "none"
});

function SvgFilterSettingsSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filter_Settings_Sort",
    "data-name": "Filter, Settings, Sort",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSettingsSort);
export default __webpack_public_path__ + "static/media/Filter, Settings, Sort.89ff5d2a.svg";
export { ForwardRef as ReactComponent };